var UserRegisterService = /** @class */ (function () {
    function UserRegisterService() {
    }
    return UserRegisterService;
}());
export { UserRegisterService };
